<template>
  <div id="year_over_year_plots" class="border-padding">
  <main>
    <div class="row">
      <div class="col-md-2" v-if="season_type_dropdown.data != undefined">
        <season-type-select v-model="season_type_selected" :options="season_type_dropdown"></season-type-select>
      </div>
      <div class="col-md-3" v-if="left_axis_dropdown.data != undefined">
        <label class="typo__label">{{ left_axis_dropdown.label }}</label>
        <multiselect
          v-model="left_axis_selected"
          select-label=""
          deselect-label=""
          track-by="id"
          label="text"
          :preselect-first="true"
          :options="left_axis_dropdown.data"
          :searchable="false"
          :show-labels="false"
          :allow-empty="false">
          <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
        </multiselect>
      </div>
      <div class="col-md-3" v-if="right_axis_dropdown.data != undefined">
        <label class="typo__label">{{ right_axis_dropdown.label }}</label>
        <multiselect
          v-model="right_axis_selected"
          select-label=""
          deselect-label=""
          track-by="id"
          label="text"
          :preselect-first="true"
          :options="right_axis_dropdown.data"
          :searchable="false"
          :show-labels="false"
          :allow-empty="false">
        <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
        </multiselect>
      </div>
    </div>

    <div class="border-padding">
      <button class="" v-on:click="changeStats()">Show Graph</button>
    </div>

    <div v-if="loading">
      Loading.....
    </div>
    <p style="color:red;" v-if="show_error_message">Error Getting Results</p>

    <svg width="960" height="600"></svg>
    <div id='table'></div>

  </main>
  </div>
</template>

<script>
import axios from 'axios'
import GetDropdownOptions from './mixins/get_dropdown'
import Multiselect from 'vue-multiselect'
import SeasonTypeSelect from './mixins/SeasonTypeSelect.vue'
import { season, seasonType, chart } from './mixins/dropdowns'
const d3 = require('d3')

export default {
  name: 'YearOverYear',
  components: {
    Multiselect,
    SeasonTypeSelect
  },
  mixins: [SeasonTypeSelect, GetDropdownOptions, season, seasonType, chart],
  data () {
    return {
      loading: false,
      season_type_dropdown: {},
      season_type_selected: undefined,
      left_axis_dropdown: {},
      left_axis_selected: undefined,
      right_axis_dropdown: {},
      right_axis_selected: undefined,
      show_error_message: false,
      api_endpoint: 'get-league-year-over-year-plots/'
    }
  },
  created () {
    this.loadData()
  },
  watch: {
    '$route': 'updateData',
    '$parent.league': 'changeLeague'
  },
  methods: {
    changeLeague () {
      d3.selectAll('svg > *').remove()
      d3.select('#table').html('')
      this.results = []
      this.season_selected_string = ''
      this.$router.push({name: 'year_over_year_plot', params: {league: this.$parent.league}})
    },
    setAxisDropdowns () {
      this.left_axis_dropdown = {'label': 'Left Axis', 'data': this.chart_dropdown_options}
      this.right_axis_dropdown = {'label': 'Right Axis (Optional)', 'data': [{'id': '', 'text': ''}].concat(this.chart_dropdown_options)}

      this.left_axis_dropdown.data.forEach((leftAxis) => {
        if (leftAxis.id === this.$route.query.LeftAxis) {
          this.left_axis_selected = leftAxis
        }
      })

      this.right_axis_dropdown.data.forEach((rightAxis) => {
        if (rightAxis.id === this.$route.query.RightAxis) {
          this.right_axis_selected = rightAxis
        }
      })
    },
    checkIfStatsShouldBeLoaded () {
      if (this.season_type_selected && this.left_axis_selected) {
        this.getStats()
      }
    },
    loadData () {
      this.getDropdown([this.setSeasonTypeDropdown, this.setAxisDropdowns, this.checkIfStatsShouldBeLoaded])
    },
    updateData () {
      if (this.$route.query.SeasonType && this.$route.query.LeftAxis) {
        this.getStats()
      } else {
        this.loadData()
      }
    },
    changeStats () {
      var params = {}

      params[this.$seasonTypeParam] = this.season_type_selected.id
      params['LeftAxis'] = this.left_axis_selected.id
      if (this.right_axis_selected) {
        if (this.right_axis_selected.id !== '') {
          params['RightAxis'] = this.right_axis_selected.id
        }
      }

      this.$router.push({name: 'year_over_year_plot', query: params})
    },
    getStats () {
      this.show_error_message = false
      var params = this.$route.query

      if (params.SeasonType && params.LeftAxis) {
        this.loading = true
        axios.get(process.env.API_BASE_URL + this.api_endpoint + this.$route.params.league, {
          params: params
        })
          .then((response) => {
            if (!response.data.error) {
              this.results = response.data.results
              this.left_axis_label = response.data.left_axis_label
              this.right_axis_label = response.data.right_axis_label
              this.addChart()
              this.loading = false
            } else {
              this.show_error_message = true
            }
            this.loading = false
          }, (error) => {
            this.show_error_message = true
            this.loading = false
            this.error = error
          })
      }
    },
    addChart () {
      d3.selectAll('svg > *').remove()
      d3.select('#table').html('')
      var margin = {top: 20, right: 40, bottom: 30, left: 50}
      var width = 960 - margin.left - margin.right
      var height = 500 - margin.top - margin.bottom

      var svg = d3.select('svg')
        .attr('width', width + margin.left + margin.right)
        .attr('height', height + margin.top + margin.bottom)
        .append('g')
        .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')

      var tableColumns = [{'label': 'season', 'header': 'Season'}, {'label': 'left_value', 'header': this.left_axis_label}]

      var leftMax = d3.max([d3.max(this.results, function (d) { return d.left_value })])
      var leftMin = d3.min([d3.min(this.results, function (d) { return d.left_value })])

      if (this.left_axis_label.indexOf('%') !== -1) {
        leftMin = 0
      }

      if (this.left_axis_label.indexOf('Frequency') !== -1) {
        leftMin = 0
      }

      var x = d3.scaleBand().domain(this.results.map(function (d) { return d.season })).rangeRound([0, width])
      var left = d3.scaleLinear().domain([0.9 * leftMin, 1.1 * leftMax]).range([height, 0])

      var valueline = d3.line()
        .x(function (d) { return x(d.season) + (x.bandwidth() / 2) })
        .y(function (d) { return left(d.left_value) })

      // Add the valueline path.
      svg.append('path')
        .data([this.results])
        .attr('class', 'left-line')
        .attr('d', valueline)

      // Add the x Axis
      svg.append('g')
        .attr('transform', 'translate(0,' + height + ')')
        .call(d3.axisBottom(x))

      // Add the left Axis
      svg.append('g')
        .attr('class', 'left-axis')
        .call(d3.axisLeft(left))

      // left label
      svg.append('text')
        .attr('transform', `rotate(270) translate(${-height / 2} ${-margin.left})`)
        .attr('dy', 12) // adjust distance from the left edge
        .attr('class', 'left-axis-label')
        .attr('text-anchor', 'middle')
        .text(this.left_axis_label)

      if (this.results[0].right_value) {
        var rightMax = d3.max([d3.max(this.results, function (d) { return d.right_value })])
        var rightMin = d3.min([d3.min(this.results, function (d) { return d.right_value })])

        if (this.right_axis_label.indexOf('%') !== -1) {
          rightMin = 0
        }

        if (this.right_axis_label.indexOf('Frequency') !== -1) {
          rightMin = 0
        }

        var right = d3.scaleLinear().domain([0.9 * rightMin, 1.1 * rightMax]).range([height, 0])

        var rightValueline = d3.line()
          .x(function (d) { return x(d.season) + (x.bandwidth() / 2) })
          .y(function (d) { return right(d.right_value) })

        // Add the valueline path.
        svg.append('path')
          .data([this.results])
          .attr('class', 'right-line')
          .attr('d', rightValueline)

        // Add the right Axis
        svg.append('g')
          .attr('class', 'right-axis')
          .attr('transform', 'translate(' + width + ',0)')
          .call(d3.axisLeft(right))

        // right label
        svg.append('text')
          .attr('transform', `rotate(270) translate(${-height / 2} ${width + 10})`)
          .attr('dy', 12)
          .attr('class', 'right-axis-label')
          .attr('text-anchor', 'middle')
          .text(this.right_axis_label)

        tableColumns.push({'label': 'right_value', 'header': this.right_axis_label})
      }
      this.tabulate(this.results, tableColumns)
    },
    tabulate (data, columns) {
      var table = d3.select('div#table').append('table').attr('style', 'margin-left: 400px')
      var thead = table.append('thead')
      var tbody = table.append('tbody')

      // append the header row
      thead.append('tr')
        .selectAll('th')
        .data(columns)
        .enter()
        .append('th')
        .attr('class', 'year-over-year')
        .text(function (column) { return column.header })

      // create a row for each object in the data
      var rows = tbody.selectAll('tr')
        .data(data)
        .enter()
        .append('tr')
        .attr('class', 'year-over-year')

      // create a cell in each row for each column
      rows.selectAll('td')
        .data(function (row) {
          return columns.map(function (column) {
            return {column: column.label, value: row[column.label]}
          })
        })
        .enter()
        .append('td')
        .attr('class', 'year-over-year')
        .html(function (d) { return d.value })
    }
  }
}
</script>

<style>
table.year-over-year, th.year-over-year, td.year-over-year {
    border: 1px solid black;
}

.left-line {
  fill: none;
  stroke: blue;
  stroke-width: 2px;
}

.left-axis text {
  fill: blue;
}

.right-line {
  fill: none;
  stroke: red;
  stroke-width: 2px;
}

.right-axis text {
  fill: red;
}
</style>



// WEBPACK FOOTER //
// src/components/YearOverYear.vue